import { useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

const variants = [
  { name: 'Ghost', color: 'var(--ghost)' },
  { name: 'Predator', color: 'var(--predator)' },
  { name: 'Animal', color: 'var(--animal)' },
  { name: 'Intimacy', color: 'var(--intimacy)' },
  { name: 'Euphoria', color: 'var(--euphoria)' },
  { name: 'Aftermath', color: 'var(--aftermath)' },
]

function MarqueeRow({ items, reverse = false, speed = 35 }) {
  const doubled = [...items, ...items]

  return (
    <div className={`marquee-row ${reverse ? 'reverse' : ''}`}>
      <div className="marquee-track" style={{ animationDuration: `${speed}s` }}>
        {doubled.map((item, i) => (
          <span key={i} className="marquee-item" style={{ '--item-color': item.color }}>
            <span className="marquee-name">{item.name}</span>
          </span>
        ))}
      </div>
    </div>
  )
}

export default function QuoteBreak() {
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end start'],
  })

  // Scroll-driven parallax offset on top of the CSS infinite scroll
  const x1 = useTransform(scrollYProgress, [0, 1], [0, -300])
  const x2 = useTransform(scrollYProgress, [0, 1], [-100, 200])

  return (
    <section className="quote-break" ref={ref}>
      <motion.div style={{ x: x1 }}>
        <MarqueeRow items={variants} speed={40} />
      </motion.div>
      <motion.div style={{ x: x2 }}>
        <MarqueeRow items={[...variants].reverse()} reverse speed={50} />
      </motion.div>
    </section>
  )
}
